import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

interface TestimonialsComponent extends InitSwiperComponent {
  rootEl: HTMLElement | null;

  closeVideoModal(): void;
}

export default function initTestimonials() {
  Alpine.data(
    'testimonials',
    (): TestimonialsComponent => ({
      rootEl: null,
      swiper: null,
      init() {
        // @ts-ignore
        const testimonials = this.$el as HTMLElement;
        this.rootEl = testimonials;
        const swiperEl = testimonials.querySelector('.swiper-testimonials');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        const { size } = domEl.dataset;
        const slideSize = Math.min(Number(size), 4);
        const nextEl = this.rootEl
          ?.querySelector<HTMLElement>('.swiper-testimonials__buttons .swiper-button-next') ?? null;
        const prevEl = this.rootEl
          ?.querySelector<HTMLElement>('.swiper-testimonials__buttons .swiper-button-prev') ?? null;

        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 20,
          slidesPerView: 4,
          navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: Math.min(slideSize, 3),
            },
            1400: {
              slidesPerView: slideSize,
            },
          },
        });
      },
      closeVideoModal() {
        // @ts-ignore
        const testimonialModal = this.$el.parentNode.parentNode;
        if (testimonialModal) {
          const innerWrap = testimonialModal.querySelector('.inner-wrap');
          if (innerWrap) {
            innerWrap.innerHTML = '<div class="plyr__video-embed video-wrap"></div>';
          }
          testimonialModal.classList.remove('show');
          document.body.classList.remove('menu-opened');
        }
      },
    }),
  );
}
